import {MxHTMLAttribute} from 'src/app/shared/models/mx-html-attribute.interface';
import {TrackableActionProps} from 'src/app/shared/models/trackable-action-props.interface';
import {createTrackHtmlAttribute} from 'src/app/shared/utils/create-track-html-attribute';
import {getTitleAndUpdatedKeyFromMxResources} from 'src/app/shared/utils/get-title-and-updated-key-from-mx-resources';

declare let mxEventSource: any; // it exists globally
declare let mxEventObject: any; // it exists globally
declare let mxResources: any; // it exists globally
export class ActionsHub {
  actions: any = {};

  constructor() {
    mxEventSource.bind(Action);
  }

  addAction(key, funct, active?, iconCls?, image?, shortcut?) {
    const {key: updatedKey, title} = getTitleAndUpdatedKeyFromMxResources(key);

    return this.put(updatedKey, new Action(title, funct, active, iconCls, image, shortcut));
  }

  public addTrackableAction(
    key: string,
    {funct, active, iconCls, image, shortcut, q9Track}: TrackableActionProps
  ): Action {
    const {key: updatedKey, title} = getTitleAndUpdatedKeyFromMxResources(key);
    const trackHtmlAttribute = createTrackHtmlAttribute(q9Track);

    return this.put(
      updatedKey,
      new Action(title, funct, active, iconCls, image, shortcut, [trackHtmlAttribute])
    );
  }

  /**
   * Registers the given action under the given name.
   */
  put(name, action) {
    if (this.actions[name]) {
      throw new Error('Action exists');
    }

    this.actions[name] = action;

    return action;
  }

  get(name) {
    return this.actions[name];
  }
}

export class Action {
  selectedCallback: any;
  toggleAction: any;
  fireEvent: any;
  active: (() => any) | boolean;
  label: string;
  funct: () => any;
  enabled: boolean;
  iconCls: string | null;
  image: () => string | null;
  shortcut: any;
  visible: boolean;
  rowTitle: () => string | boolean | null;
  dynamicLabel: () => string | null;

  // enabled - 	Optional boolean indicating if the item is enabled.  Default is true.
  // active -	Optional boolean indicating if the menu should implement any event handling. Default is true.

  constructor(
    label,
    funct,
    active,
    iconCls,
    image,
    shortcut,
    public attributes?: MxHTMLAttribute[]
  ) {
    this.label = label;
    this.funct = funct;
    this.active = active;
    this.iconCls = iconCls;
    this.image = image;
    this.shortcut = shortcut;
    this.visible = true;
  }

  public getImage() {
    return typeof this.image === 'function' ? this.image() : null;
  }

  public isActive() {
    return typeof this.active === 'function' ? this.active() : true;
  }

  public getRowTitle() {
    return typeof this.rowTitle === 'function' && this.rowTitle();
  }

  public getDynamicLabel() {
    const registryKey = typeof this.dynamicLabel === 'function' ? this.dynamicLabel() : null;

    return registryKey ? mxResources.get(registryKey) : null;
  }

  public setEnabled(value) {
    if (this.enabled !== value) {
      this.enabled = value;
      this.fireEvent(new mxEventObject('stateChanged'));
    }
  }

  public setRowTitle(callback) {
    this.rowTitle = callback;

    return this;
  }

  public setDynamicLabel(callback) {
    this.dynamicLabel = callback;

    return this;
  }

  public isEnabled(): boolean {
    return this.enabled || true;
  }

  public setToggleAction(value) {
    this.toggleAction = value;
  }

  public setSelectedCallback(funct) {
    this.selectedCallback = funct;
  }

  public isSelected() {
    return this.selectedCallback();
  }
}
